<template>
  <el-dialog
    :visible="true"
    :modal-append-to-body="false"
    :before-close="close"
    width="600px"
    :title="$t('Metabase_MetabaseComputation_Dialog_Title')"
    center
  >
    <el-table :data="data.attributes">
      <el-table-column
        prop="name"
        :label="$t('Metabase_MetabaseComputation_Dialog_Field_Name')"
      />
      <el-table-column
        prop="type"
        :label="$t('Metabase_MetabaseComputation_Dialog_Field_Type')"
        :formatter="typeFormatter"
        width="150px"
      />
      <el-table-column
        :label="$t('Metabase_MetabaseComputation_Dialog_Field_Default')"
        width="150px"
      >
        <template slot-scope="scope">
          <checkbox
            :disabled="readonly"
            :title="$t('Metabase_MetabaseComputation_Dialog_Field_Default_0')"
            v-model="notNull[scope.row.name]"
            v-if="notNullAllowed(scope.row.type)"
          />
          <span v-else>
            N/A
          </span>
        </template>
      </el-table-column>
    </el-table>

    <div class="errors">
      <div class="error-block" v-for="(errorList, name) in data.errors">
        <div class="item-name">
          {{ name }}
        </div>
        <ul class="item-errors">
          <li v-for="item in errorList">{{ item }}</li>
        </ul>
      </div>
    </div>

    <div slot="footer" class="dialog-footer" v-if="!readonly">
      <div class="frequency" v-if="!hasErrors">
        <enum-select
          v-model="frequency"
          :options="MetabaseComputationFrequencySelectEnum"
          :placeholder="
            $t(
              'Metabase_MetabaseComputation_Dialog_Field_Frequency_Placeholder'
            )
          "
        />
      </div>
      <div class="buttons">
        <el-button type="primary" plain @click="close">
          {{ $t('Metabase_MetabaseComputation_Dialog_Cancel') }}
        </el-button>
        <el-button type="primary" @click="confirm" v-if="!hasErrors">
          {{ $t('Metabase_MetabaseComputation_Dialog_Confirm') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { TagType, TagTypeLabels } from '../../data-manager/enum/TagTypeEnum'
import EnumSelect from '../../../common/components/form/EnumSelect.vue'
import { MetabaseComputationFrequencySelectEnum } from '../enum/MetabaseComputationFrequencyEnum'
import Checkbox from '../../../common/components/form/Checkbox.vue'

export default {
  name: 'MetabaseComputationDialog',
  components: { Checkbox, EnumSelect },

  props: {
    data: {
      type: Object,
      required: true
    },

    readonly: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      frequency: null,
      notNull: {}
    }
  },

  created() {
    this.notNull = this.data.not_null
  },

  methods: {
    close() {
      this.$emit('close')
    },

    confirm() {
      this.$emit('confirm', {
        frequency: this.frequency,
        not_null: Object.assign({}, this.notNull)
      })
    },

    notNullAllowed(type) {
      return (
        !this.notRealtimeSelected &&
        (type === TagType.NUMBER || type === TagType.INTEGER)
      )
    },

    typeFormatter(row, col, value) {
      return this.$t(TagTypeLabels[value])
    }
  },

  computed: {
    MetabaseComputationFrequencySelectEnum() {
      return MetabaseComputationFrequencySelectEnum
    },

    hasErrors() {
      if (Array.isArray(this.data.errors)) {
        return !!this.data.errors.length
      } else {
        return !!Object.keys(this.data.errors).length
      }
    },

    notRealtimeSelected() {
      return this.frequency && this.frequency !== 'realtime'
    }
  },

  watch: {
    frequency: function(frequency) {
      if (frequency && frequency !== 'realtime') {
        Object.keys(this.notNull).forEach(attr => {
          this.notNull[attr] = 0
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-footer {
  display: flex;
  justify-content: space-between;
}

.frequency {
  >>> input {
    width: 240px;
    height: 36px !important;
    line-height: 36px !important;
  }
}

.errors {
  .error-block {
    border: 1px solid #dbdee7;
    padding: 20px;
    border-radius: 4px;
    margin-top: 20px;
    .item-name {
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      color: #5c6374;
    }
    .item-errors {
      font-size: 14px;
      line-height: 22px;
      color: #f14951;
      list-style: disc !important;
      padding-left: 18px;

      li {
        word-break: normal;
      }

      li:first-letter {
        text-transform: uppercase;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/metabase/components/MetabaseComputationDialog.vue